module.exports = __webpack_public_path__ + "img/watage_res_5.f3e7ef79.gif";